import ProximaNovaW01RegularWOFF from "./Fonts/52ed7b2d-8a31-4b18-a1d5-8685608b0889.woff"
import ProximaNovaW01RegularWOFF2 from "./Fonts/b38b8bd9-d96f-4bf9-add1-adbd2b08b802.woff2"
import ProximaNovaW01BoldWOFF from "./Fonts/332136cf-33d0-43fb-97ee-49c7742489ff.woff"
import ProximaNovaW01BoldWOFF2 from "./Fonts/cc85d073-4dcf-4ecd-9804-40c34e631e2b.woff2"
// import AvertaRegularWOFF from "./Fonts/fa982202-5e4a-491e-a2c1-8daa85685402.woff"
// import AvertaRegularWOFF2 from "./Fonts/1c578a3b-763b-451e-8ae0-a90ba63a80be.woff2"
import MontserratBold from "./Fonts/Montserrat-Bold.woff2"
import MontserratLight from "./Fonts/Montserrat-Light.woff2"
import MontserratRegular from "./Fonts/Montserrat-Regular.woff2"

const FontsExport = {
    ProximaNovaW01RegularWOFF,
    ProximaNovaW01RegularWOFF2,
    ProximaNovaW01BoldWOFF,
    ProximaNovaW01BoldWOFF2,
    MontserratBold,
    MontserratLight,
    MontserratRegular
}

export default FontsExport